import React from 'react'
import { Table } from 'react-bootstrap';

interface RecordInfoTableProps {
    recordTableData: any[];
}

const RecordInfoTable: React.FC<RecordInfoTableProps> = ({ recordTableData }) => {

    if (!(recordTableData.length > 0)) return null;

    return (
        <div className="record-item-info-table-wrapper">
            <Table bordered={false} hover={true} className='m-0'>
                <thead>
                    <tr>
                        <th>Barcode</th>
                        <th>Item Name</th>
                        <th>NDC/SKU</th>
                        <th>Lot</th>
                        <th>Exp.Date</th>
                        <th>Stock</th>
                        <th>Quantity</th>
                        <th>Unit</th>
                        <th>Waste</th>
                    </tr>
                </thead>
                <tbody>
                    {recordTableData.map((data: any, index: number) => (
                        <tr key={index}>
                            <td>{data.bcScan ?? "-"}</td>
                            <td>{data.rxName ?? "-"}</td>
                            <td>{data.ndc ?? "-"}</td>
                            <td>{data.lotNo ?? "-"}</td>
                            <td>{data.expDate ?? "-"}</td>
                            <td>{data.list2 ?? "-"}</td>
                            <td>{data.qty ?? "-"}</td>
                            <td>{data.unit ?? "-"}</td>
                            <td>{data.waste ?? "-"}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    )
}

export default RecordInfoTable;
